// extracted by mini-css-extract-plugin
export var accessoireImg = "style-mod--accessoire-img--7de83";
export var accessorieImg = "style-mod--accessorie-img--36719";
export var addToCart = "style-mod--add-to-cart--e5366";
export var added = "style-mod--added--9108f";
export var cartBtn = "style-mod--cart-btn--e7bbc";
export var cartButton = "style-mod--cart-button--565f9";
export var checkService = "style-mod--check-service--616d3";
export var compareAtPriceStyle = "style-mod--compare-at-price-style--2d6c7";
export var containerTitle = "style-mod--container-title--94fdd";
export var content = "style-mod--content--14dd3";
export var contentAccessoire = "style-mod--content-accessoire--3ff7c";
export var contentBottom = "style-mod--content-bottom--a6458";
export var crossSellAccessoireSelected = "style-mod--cross-sell-accessoire-selected--f400f";
export var crossSellContainerDesktop = "style-mod--cross-sell-container-desktop--22c69";
export var description = "style-mod--description--bee6c";
export var extraService = "style-mod--extra-service--3ebc3";
export var image = "style-mod--image--dfc90";
export var outOfStock = "style-mod--out-of-stock--3e521";
export var outOfStockInfo = "style-mod--out-of-stock-info--497ab";
export var plus = "style-mod--plus--1a919";
export var price = "style-mod--price--0bdbc";
export var priceAtCompare = "style-mod--price-at-compare--87e3b";
export var priceAtCompareTotal = "style-mod--price-at-compare-total--38fb4";
export var priceContainer = "style-mod--price-container--d11d7";
export var prices = "style-mod--prices--d8730";
export var productContainer = "style-mod--product-container--fd9e0";
export var productTitle = "style-mod--product-title--2de3b";
export var regularCheckbox = "style-mod--regular-checkbox--14a21";
export var saveMoney = "style-mod--save-money--64800";
export var serviceContainer = "style-mod--service-container--e78fc";
export var servicePrice = "style-mod--service-price--73b81";
export var servicePriceAtCompare = "style-mod--service-price-at-compare--ca253";
export var servicePrices = "style-mod--service-prices--9d736";
export var serviceTitle = "style-mod--service-title--8b032";
export var slideContent = "style-mod--slide-content--9fdf6";
export var slideImage = "style-mod--slide-image--6f3ab";
export var slideProduct = "style-mod--slide-product--05bb9";
export var slideSaveMoney = "style-mod--slide-save-money--12f26";
export var sumContainer = "style-mod--sum-container--fbdb0";
export var textPrice = "style-mod--text-price--6bfeb";
export var titleAndDesc = "style-mod--title-and-desc--8a1aa";
export var variantTitleStyle = "style-mod--variant-title-style--c73b7";